module.exports = __webpack_public_path__ + "static/media/24UHCHR25.0fc1ad52.jpg";